import { useEffect, useState } from "react";
import { apiUrl, executeRequest, getToken } from "../../functions/requests";
import Spacer from "../../components/Spacer";
import FormInput from "../../components/FormInput";
import Button from "../../components/Button";
import IconCheck from "../../icons/IconCheck";

export default function UserCreate({ userData, onCancelled, onCreated }) {
  const [loading, setLoading] = useState(true);
  const [canSubmitData, setCanSubmitData] = useState(false);
  const [userRoles, setUserRoles] = useState(null);
  const [newUserData, setNewUserData] = useState({});

  // Check if user can submit the data
  const checkCanSubmitData = () => {
    const isValid =
      newUserData &&
      newUserData.first_name &&
      newUserData.last_name &&
      newUserData.email &&
      newUserData.phone &&
      newUserData.password &&
      newUserData.password > 7;

    console.log(isValid);

    setCanSubmitData(isValid);
  };

  useEffect(() => {
    checkCanSubmitData();
  }, [newUserData]);

  // Get available roles
  const getUserRoles = async () => {
    setLoading(true);
    await executeRequest(
      apiUrl + "users/roles",
      "GET",
      null,
      {
        Authorization: "Bearer " + getToken(),
      },
      async (data) => {
        setUserRoles(data);
      },
      (error) => {
        console.log(error);
      }
    );
    setLoading(false);
  };

  // Create user
  const addNewUser = async () => {
    if (userData == null) return;
    setLoading(true);
    const finalFields = new FormData();
    for (let key in newUserData) {
      if (newUserData.hasOwnProperty(key)) {
        // If the value is a File (e.g., image or other binary data)
        if (newUserData[key] instanceof File) {
          finalFields.append(key, newUserData[key]);
        } else {
          // Append other data as strings
          finalFields.append(key, newUserData[key]);
        }
      }
    }

    // Conditional URL depending on user type
    let url =
      userData.user_type !== "user"
        ? apiUrl + "customer-users"
        : apiUrl + "users";

    await executeRequest(
      url,
      "POST",
      finalFields,
      {
        Authorization: "Bearer " + getToken(),
      },
      (data) => {
        onCreated(data);
      },
      (error) => {
        console.log(error);
      }
    );
    setLoading(false);
  };

  useEffect(() => {
    getUserRoles();
  }, []);

  return (
    <div>
      <h1 className="page-title">Add new user</h1>
      <Button
        text="< Back to users"
        type="underlined"
        onClicked={() => {
          if (loading) return;
          onCancelled();
        }}
      />
      <Spacer />
      <FormInput
        type="text"
        title="First name"
        value={newUserData ? newUserData.first_name : ""}
        onChanged={(value) =>
          setNewUserData({
            ...newUserData,
            first_name: value,
          })
        }
      />
      <Spacer />
      <FormInput
        type="text"
        title="Last name"
        value={newUserData ? newUserData.last_name : ""}
        onChanged={(value) =>
          setNewUserData({
            ...newUserData,
            last_name: value,
          })
        }
      />
      <Spacer />
      <FormInput
        type="email"
        title="Email"
        value={newUserData ? newUserData.email : ""}
        onChanged={(value) =>
          setNewUserData({
            ...newUserData,
            email: value,
          })
        }
      />
      <Spacer />
      <FormInput
        type="text"
        title="Phone"
        value={newUserData ? newUserData.phone : ""}
        onChanged={(value) =>
          setNewUserData({
            ...newUserData,
            phone: value,
          })
        }
      />
      <Spacer />
      <FormInput
        type="text"
        title="Password"
        value={newUserData ? newUserData.password : ""}
        onChanged={(value) =>
          setNewUserData({
            ...newUserData,
            password: value,
          })
        }
      />
      <Spacer />
      {userRoles !== null && (
        <>
          <FormInput
            type="select"
            title="Role"
            value={newUserData.role}
            selectOptions={userRoles}
            selectAllowEmptyOption={true}
            onChanged={(value) =>
              setNewUserData({
                ...newUserData,
                role: value,
              })
            }
          />
          <Spacer />
        </>
      )}
      <Button
        icon={<IconCheck />}
        text="Add"
        loading={loading}
        disabled={!canSubmitData}
        onClicked={() => addNewUser()}
      />
    </div>
  );
}
